import { PathWithId } from "@constellation-academy/epic-ui";
import { PersonalizedNotificationTemplateEditPath } from "../personalized-notification-template-edit/personalized-notification-template-edit.paths";

export class PersonalizedNotificationTemplatesPath extends PathWithId<
	typeof PersonalizedNotificationTemplatesPath
> {
	static readonly pathKey = "personalizedNotificationTemplates";
	static readonly pathName = "personalized-notification-templates";
	static readonly idKey = "personalizedNotificationTemplateId";
	static readonly childPaths = [PersonalizedNotificationTemplateEditPath];
}
